import {Link as RoutedLink} from 'react-router-dom';

import {Link} from 'shells/link/link';

export function NutshellMarketingUpsell() {
    return (
        <div>
            Try Nutshell Campaigns:{' '}
            <Link
                variant='primary'
                to={
                    NutClientConfig.shouldShowEmailMarketingLiftingOfTheCurtainCTA ||
                    NutClientConfig.shouldShowEmailMarketingLiftingOfTheCurtain
                        ? '/email-marketing/summary'
                        : '/email-marketing/audiences'
                }
                // @ts-expect-error
                as={RoutedLink}
                size='small'
            >
                Create an audience
            </Link>
        </div>
    );
}
